export enum FooterRowAction {
  None = 0,
  Count = 1,
  Sum = 2,
  Min = 3,
  Max = 4,
  Avg = 5
}
